import React from 'react'
import { ERROR_CODES } from 'api/response'
import { ExtendedError } from 'store/types'
import { Text, Box, Icon } from 'components'
import AccessDenied from 'modules/shared/AccessDenied'

type Props = {
  error?: ExtendedError | null
  message?: string
}

const ShowError: React.FC<Props> = ({ error, message }) => {
  if (error) {
    switch (error.code) {
      case ERROR_CODES.INVALID_PERMISSION:
        return <AccessDenied />
    }
  }

  return (
    <Box height="calc(100vh - 60px)" display="flex" alignItems="center" justifyContent="center" mx="50px">
      <Box>
        <Box display="flex" justifyContent="center">
          <Icon fontSize={60} icon={['fas', 'exclamation-circle']} color="red" />
        </Box>
        <Text fontSize={28} fontWeight="medium" textAlign="center" my="16px" color="red">
          something_went_wrong_error
        </Text>
        {message && (
          <Text textAlign="center" color="red">
            {message}
          </Text>
        )}
        {!message && error && (
          <>
            <Text textAlign="center" color="red">
              {error.name}
            </Text>
            <Text textAlign="center" marginTop={10} color="red">
              {error.message}
            </Text>
          </>
        )}
      </Box>
    </Box>
  )
}

export default ShowError
